"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebGlAttributes = void 0;
// Using this enum to set the values instead of directly using WebGLRenderingContext.prototype
// because webGl is not accessible within the unit tests (tests could be run in some headless browser context)
var WebGlAttribute;
(function (WebGlAttribute) {
    WebGlAttribute[WebGlAttribute["NONE"] = 0] = "NONE";
    WebGlAttribute[WebGlAttribute["BYTE"] = 5120] = "BYTE";
    WebGlAttribute[WebGlAttribute["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    WebGlAttribute[WebGlAttribute["SHORT"] = 5122] = "SHORT";
    WebGlAttribute[WebGlAttribute["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    WebGlAttribute[WebGlAttribute["INT"] = 5124] = "INT";
    WebGlAttribute[WebGlAttribute["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    WebGlAttribute[WebGlAttribute["FLOAT"] = 5126] = "FLOAT"; // WebGLRenderingContext.prototype.FLOAT
})(WebGlAttribute || (WebGlAttribute = {}));
class WebGlAttributes {
    static toWebGlAttribute(type) {
        return this.webGlAttributesMap[type];
    }
    static toAttributeSize(type) {
        return this.attributeSizeMap[type];
    }
}
exports.WebGlAttributes = WebGlAttributes;
WebGlAttributes.webGlAttributesMap = [
    WebGlAttribute.NONE,
    WebGlAttribute.BYTE,
    WebGlAttribute.UNSIGNED_BYTE,
    WebGlAttribute.SHORT,
    WebGlAttribute.UNSIGNED_SHORT,
    WebGlAttribute.INT,
    WebGlAttribute.UNSIGNED_INT,
    WebGlAttribute.FLOAT
];
WebGlAttributes.attributeSizeMap = [0, 1, 1, 2, 2, 4, 4, 4, 8];
WebGlAttributes.UNSIGNED_BYTE_TYPE = 2;
